import { useForm } from '@givebacks/formy';
import { Stack, TextInput } from 'ui';
import { hasLength } from 'ui/Form';

import { AddStudentFormValues } from './addStudentForm.types';

type AddStudentFormProps = {
  resetError: () => void;
};

const AddStudentForm = ({ resetError }: AddStudentFormProps) => {
  const form = useForm<AddStudentFormValues>(
    {
      initialValues: {
        firstName: '',
        lastName: '',
        studentId: '',
      },
      validate: {
        firstName: hasLength({ min: 1 }, 'First name is required'),
        lastName: hasLength({ min: 1 }, 'Last name is required'),
        studentId: hasLength({ min: 1 }, 'Student ID is required'),
      },
      onValuesChange: () => {
        resetError();
      },
    },
    {
      id: 'add-student-form',
    }
  );

  return (
    <Stack gap="sm">
      <TextInput
        label="First Name"
        placeholder="Enter First Name"
        required
        {...form.getInputProps('firstName')}
      />
      <TextInput
        label="Last Name"
        placeholder="Enter Last Name"
        required
        {...form.getInputProps('lastName')}
      />
      <TextInput
        label="Student ID"
        placeholder="Enter Student ID"
        required
        {...form.getInputProps('studentId')}
      />
    </Stack>
  );
};

export { AddStudentForm };
